var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-switch',{on:{"change":_vm.switchChange},model:{value:(_vm.modelVal),callback:function ($$v) {_vm.modelVal=$$v},expression:"modelVal"}},[_c('div',{staticClass:"ssssss"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }